import React from "react";
import { LayoutDashboard } from 'lucide-react';
import { NavItem } from "../NavItem";

export function DashboardLink({ isCollapsed }) {
    return (
        <NavItem
            redirectUrl="/"
            Icon={LayoutDashboard}
            label="Dashboard"
            isCollapsed={isCollapsed}
        />
    );
}
